export const categories = [
  {
    id: 1,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648467/coding/NucbaZappi/Categorias/pizzas_unnxwp.png',
    title: 'Pizzas',
    category: 'Pizzas',
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648466/coding/NucbaZappi/Categorias/hamburguesa_faykp7.png',
    title: 'Hamburguesas',
    category: 'Hamburguesas',
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648466/coding/NucbaZappi/Categorias/papas-fritas_uw3tat.png',
    title: 'Napapuki',
    category: 'Napapuki',
  },
  {
    id: 4,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656656873/coding/NucbaZappi/Categorias/LaPiedra_g5lhgf.png',
    title: 'Pizzas a la piedra',
    category: 'PizzasALaPiedra',
  },
  {
    id: 5,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648466/coding/NucbaZappi/Categorias/burritos_osec1e.png',
    title: 'Wraps',
    category: 'Wraps',
  },
  {
    id: 6,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648466/coding/NucbaZappi/Categorias/tacos_hdr7i2.png',
    title: 'Mexican Food',
    category: 'MexicanFood',
  },
  {
    id: 7,
    img: 'https://res.cloudinary.com/dcatzxqqf/image/upload/v1656648466/coding/NucbaZappi/Categorias/batidos_njcyfi.png',
    title: 'Batidukis',
    category: 'Batidukis',
  },
];